import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { FormControl, FormLabel, RadioGroup as RadioGroup$1, FormControlLabel, Radio, FormHelperText } from '@mui/material';
var _excluded = ["helperText", "label", "options", "selectedOptionId", "fullWidth", "margin", "horizontal", "ariaControls", "dataProp"];

var BaseRadioGroup = function BaseRadioGroup(_ref) {
  var helperText = _ref.helperText,
      label = _ref.label,
      options = _ref.options,
      selectedOptionId = _ref.selectedOptionId,
      fullWidth = _ref.fullWidth,
      margin = _ref.margin,
      horizontal = _ref.horizontal,
      ariaControls = _ref.ariaControls,
      _ref$dataProp = _ref.dataProp,
      dataProp = _ref$dataProp === void 0 ? 'radio-option' : _ref$dataProp,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FormControl, _extends({
    fullWidth: fullWidth
  }, rest, {
    margin: margin
  }), label && /*#__PURE__*/React.createElement(FormLabel, {
    focused: false,
    component: "legend"
  }, label), /*#__PURE__*/React.createElement(RadioGroup$1, {
    "aria-label": label,
    "aria-controls": ariaControls,
    name: "radiogroup-name-".concat(label || 'no-name-provided'),
    className: horizontal ? 'radioGroupHorizontal ' : undefined
  }, options.map(function (_ref2) {
    var id = _ref2.id,
        isEnabled = _ref2.isEnabled,
        color = _ref2.color,
        description = _ref2.description;
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      control: /*#__PURE__*/React.createElement(Radio, {
        checked: id === selectedOptionId,
        color: color,
        disabled: !isEnabled,
        inputProps: {
          checked: id === selectedOptionId,
          'data-selector': "".concat(dataProp, "-").concat(id)
        }
      }),
      value: id,
      label: description,
      key: id
    });
  })), helperText && /*#__PURE__*/React.createElement(FormHelperText, {
    style: {
      marginLeft: '0'
    }
  }, helperText));
};

BaseRadioGroup.defaultProps = {
  margin: 'normal',
  fullWidth: true
};

var arePropsEqual = function arePropsEqual(prev, next) {
  var prevOptions = prev.options;
  var nextOptions = next.options;
  var optionsAreEqual = JSON.stringify(prevOptions) === JSON.stringify(nextOptions);
  var propsAreEqual = JSON.stringify(prev) === JSON.stringify(next);
  return optionsAreEqual && propsAreEqual;
};

var RadioGroup = /*#__PURE__*/React.memo(BaseRadioGroup, arePropsEqual);
RadioGroup.displayName = 'RadioGroup';
export { RadioGroup, arePropsEqual };